import { render, staticRenderFns } from "./setup-organization.vue?vue&type=template&id=c02565e2&"
import script from "./setup-organization.ts?vue&type=script&lang=ts&"
export * from "./setup-organization.ts?vue&type=script&lang=ts&"
import style0 from "./setup-organization.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports